var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 6.58952V17.5895C19.25 18.0937 19.0706 18.5254 18.7119 18.8848C18.3526 19.2435 17.9208 19.4229 17.4167 19.4229H4.58333C4.07917 19.4229 3.64742 19.2435 3.28808 18.8848C2.92936 18.5254 2.75 18.0937 2.75 17.5895V4.75618C2.75 4.25202 2.92936 3.82027 3.28808 3.46093C3.64742 3.10221 4.07917 2.92285 4.58333 2.92285H15.5833L19.25 6.58952ZM11 16.6729C11.7639 16.6729 12.4132 16.4055 12.9479 15.8708C13.4826 15.336 13.75 14.6867 13.75 13.9229C13.75 13.159 13.4826 12.5097 12.9479 11.9749C12.4132 11.4402 11.7639 11.1729 11 11.1729C10.2361 11.1729 9.58681 11.4402 9.05208 11.9749C8.51736 12.5097 8.25 13.159 8.25 13.9229C8.25 14.6867 8.51736 15.336 9.05208 15.8708C9.58681 16.4055 10.2361 16.6729 11 16.6729ZM5.5 9.33952H13.75V5.67285H5.5V9.33952Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedSaveIcon);
export default __webpack_public_path__ + "static/media/DeprecatedSaveIcon.8b178af90b2455b3095c91223f31ae9d.svg";
export { ForwardRef as ReactComponent };